module.exports = __webpack_public_path__ + "img/qihuo.a5b836e2.jpg";